import { createSvgIcon } from "@mui/material/utils";

export const UploadCloudIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
    >
        <path
            d="M12 12.9199V21.9199M12 12.9199L9.49996 14.9199M12 12.9199L14.5 14.9199M5.03396 10.0369C4.08817 10.2749 3.26184 10.85 2.71021 11.6543C2.15859 12.4586 1.91964 13.4366 2.03827 14.4047C2.15689 15.3727 2.62492 16.2641 3.35443 16.9114C4.08393 17.5587 5.02469 17.9173 5.99996 17.9199H6.99996"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.8299 8.05788C15.4881 6.70446 14.6445 5.53163 13.47 4.77714C12.2956 4.02266 10.8782 3.74297 9.50517 3.99479C8.13215 4.2466 6.90625 5.01107 6.07598 6.13322C5.2457 7.25538 4.87318 8.65125 5.03392 10.0379C5.03392 10.0379 5.18692 10.9199 5.49992 11.4199"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17 17.9199C17.706 17.9194 18.404 17.7694 19.0479 17.4798C19.6917 17.1901 20.267 16.7674 20.7357 16.2394C21.2045 15.7114 21.5561 15.0901 21.7674 14.4165C21.9787 13.7428 22.045 13.032 21.9618 12.3309C21.8786 11.6297 21.6479 10.9542 21.2848 10.3487C20.9217 9.74313 20.4345 9.22137 19.8552 8.81771C19.276 8.41404 18.6178 8.13764 17.924 8.00668C17.2302 7.87573 16.5166 7.89319 15.83 8.05792L14.5 8.41992"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
    "UploadCloudIcon"
);
